<template>
    <v-container fluid>
        <documentos
            :donoDocumento="'patrimonio'"
            :donoDocumentoId="idPatrimonio"
        />

        <v-row align-content="end">
            <v-col cols="12">
                <listagem-documentos-acoes
                    :patrimonio="patrimonio"
                    @voltar="tratarEventoVoltar"
                    @ativar="tratarEventoAtivar"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import Documentos from '@/views/components/documento/Documentos.vue'
    import ListagemDocumentosAcoes from './ListagemDocumentosAcoes'

    import {actionTypes} from '@/core/constants'

    export default {
        name: 'ListagemDocumentos',
        data() {
            return {
                rotaOrigem: this.$store.state.rota.origem,
                idPatrimonio: this.$route.params.id,
                patrimonio: {},
                documentoVazio:true,
                showDesfazer:false,
                mostrarFormModal: false,
            }
        },
        components: {
            ListagemDocumentosAcoes,
            Documentos,
        },
        async mounted() {
            this.$gtag.event('PatrimonioCadastroListagemDocumentos', { method: 'Google' })
            await this.buscaPatrimonio()
        },
        methods: {
            async tratarEventoAtivar() {
                await this.$store.dispatch(actionTypes.PATRIMONIO.ATIVA_PATRIMONIO, this.idPatrimonio)
                this.mostrarNotificacaoSucessoDefault()
                this.verificaSePatrimonioJaCanceladoAtivacao(this.idPatrimonio)
                await this.$router.push({name: 'FichaPatrimonio', params: {id: this.idPatrimonio}})
            },
            verificaSePatrimonioJaCanceladoAtivacao(patrimonioId){
                if(this.$store.state.patrimonio.ativacaoCanceladaPatrimonioId === patrimonioId){
                    this.emiteMensagemAvisoMemorando()
                }
            },
            emiteMensagemAvisoMemorando(){
                setTimeout(() => {
                    this.mostrarNotificacaoAviso(
                        'Alterações feitas impactam o memorando. Gere novamente esse memorando!'
                    )
                }, 1500)
            },
            tratarEventoVoltar() {
                this.$router.push({
                    name: 'DadosDeEntradaEdicao',
                    params: {id: this.idPatrimonio},
                })
            },
            async buscaPatrimonio() {
                this.patrimonio = await this.$store.dispatch(actionTypes.PATRIMONIO.BUSCAR_PATRIMONIO_POR_ID, this.idPatrimonio)
            },
        }
    }
</script>
